import { useTheme, useMediaQuery } from "@mui/material";

import React, { useCallback, useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { searchCitiesAction } from "../../redux/actions/cityAddressActions";
import debounce from "lodash/debounce";
import {
  Button,
  TextField,
  Box,
  Snackbar,
  Alert,
  Grid,
  Typography,
  FormControl,
  Select,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import DatePickerField from "./DatePickerField";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { convertToE164 } from "../../common/helpers/commonFun";
import {
  alphanumericWithSpaceValidation,
  validateCity,
  validateEmail,
  validateField,
  validateStateField,
  validateMobile,
  zipCodeValidation,
  validateAddress,
} from "../../common/helpers/validation";
import {
  getGeneralPartyInfoById as getGeneralPartyInfoByIdAction,
  createGeneralPartyInfo as createGeneralPartyInfoAction,
  updateGeneralPartyInfo,
  getQuoteInfoByFields,
  getNewQuoteByGpid,
  setGpId,
} from "../../redux/actions/generalPartyInfoActions";
import {
  genderList,
  residenceship,
  stateList,
  MonthList,
  YearList,
} from "../../common/StaticFieldList";
import { tabActions } from "../../redux/actions/tabActions";

import { populateValue } from "../../common/helpers/utils";
import PhoneNumberField from "../../common/PhoneNumberField";

const requiredFields = [
  "firstName",
  "lastName",
  "email",
  "address",
  "cellPhone",
  "state",
  "gender",
  "city",
  "zip",
  "dob",
];
const validationRules = [
  {
    fieldName: "firstName",
    label: "First Name",
    type: "text",
    id: "firstnamefield",
  },
  {
    fieldName: "lastName",
    label: "Last Name",
    type: "text",
    id: "lastnamefield",
  },
  {
    fieldName: "dob",
    label: "Date Of Birth",
    type: "text",
    id: "dobfield",
    required: true,
    format: "MM-DD-YYYY",
    placeholder: "MM-DD-YYYY",
  },
  {
    fieldName: "cellPhone",
    // label: "Cell Phone",
    required: false,
    type: "number",
    id: "cellphonefield",
  },
  {
    fieldName: "email",
    label: "Email Address",
    type: "email",
    id: "emailfield",
  },

  {
    fieldName: "gender",
    label: "Gender",
    type: "select",
    option: genderList,
    id: "genderfield",
  },

  { fieldName: "address", label: "Address", type: "text", id: "addressfield" },
  {
    fieldName: "apartmentNumber",
    label: "Apartment Number",
    type: "number",
    id: "taxidfield",
  },
  { fieldName: "city", label: "City", type: "text", id: "cityfield" },
  {
    fieldName: "state",
    label: "State",
    type: "select",
    option: stateList,
    id: "statefield",
  },
  { fieldName: "zip", label: "Zipcode", type: "number", id: "zipfield" },

  {
    fieldName: "ownedRented",
    label: "Owned / Rented",
    type: "select",
    option: residenceship,
    id: "ownedrentedfield",
  },

  {
    fieldName: "residenceYear",
    label: "Years at Residence",
    type: "select",
    option: YearList,
    id: "residenceyearfield",
  },
  {
    fieldName: "residenceMonth",
    label: "Months at Residence",
    type: "select",
    option: MonthList,
    id: "residencemonthfield",
  },
];

const validationFunctions = {
  firstName: alphanumericWithSpaceValidation,
  lastName: alphanumericWithSpaceValidation,
  email: validateEmail,
  cellPhone: validateMobile,
  zip: zipCodeValidation,
  dob: (value) => {
    if (!value) return "Date of Birth is required";
    const parsedDate = dayjs(value);
    const minDate = dayjs("1940-04-04");
    const maxDate = dayjs("2008-04-04");

    if (parsedDate.isBefore(minDate)) return "Date must be after 1940-04-04";
    if (parsedDate.isAfter(maxDate)) return "Date must be before 2008-04-04";
    return "";
  },
  state: (value) => {
    if (!value) return "Please select a state";
    if (!stateList.some((state) => state.value === value))
      return "Please select a valid state";
    return "";
  },
  city: validateCity,
  address: validateAddress,
  gender: (value) => (!value ? "Please select a gender" : ""),
  ownedRented: (value) => (!value ? "Please select owned or rented" : ""),
};

const GeneralTab = forwardRef((props, ref) => {
    const { handleNext, handleSubmitGeneralTab, id, generalData, customerId } = props;

  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [quoteId,setQuoteId]=useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [existingUsers, setExistingUsers] = useState([]);
  const [hasCheckedExisting, setHasCheckedExisting] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [useGpId, setUseGpId] = useState(false);
  const newFieldArg = [...validationRules];
  const getGpId = useSelector((state) => state.generalPartyInfo.gpId)
  const [manuallyEdited, setManuallyEdited] = useState({
    firstName: false,
    lastName: false,
    dob: false,
    cellPhone: false,
  });

  const [formState, setFormState] = useState({
    formData: newFieldArg.reduce(
      (fields, { fieldName }) => ({
        ...fields,
        [fieldName]: "",
      }),
      {}
    ),
    touchedFields: newFieldArg.reduce(
      (fields, { fieldName }) => ({
        ...fields,
        [fieldName]: false,
      }),
      {}
    ),
    fieldErrors: newFieldArg.reduce(
      (errors, { fieldName }) => ({
        ...errors,
        [fieldName]: "",
      }),
      {}
    ),
  });
  const dynamicTheme = useSelector((state) => state?.theme?.theme[0]);
  const cityData = useSelector((state) => state.cityAddress?.cities || []);
  const [citySearchTerm, setCitySearchTerm] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
    useEffect(() => {
    // Check if this is a new quote (no id and no generalData)
    if (!id && !generalData) {
      // Reset form to initial empty state
      const emptyFormData = newFieldArg.reduce(
        (fields, { fieldName }) => ({
          ...fields,
          [fieldName]: "",
        }),
        {}
      );

      setFormState({
        formData: emptyFormData,
        touchedFields: newFieldArg.reduce(
          (fields, { fieldName }) => ({
            ...fields,
            [fieldName]: false,
          }),
          {}
        ),
        fieldErrors: newFieldArg.reduce(
          (errors, { fieldName }) => ({
            ...errors,
            [fieldName]: "",
          }),
          {}
        ),
      });

      // Reset other states
      setManuallyEdited({
        firstName: false,
        lastName: false,
        dob: false,
        cellPhone: false,
      });
      setHasCheckedExisting(false);
      setExistingUsers([]);
      setSelectedUser(null);
      setUseGpId(false);
      setSelectedCity(null);
      setCitySearchTerm("");
    }
  }, [id, generalData]);

  useEffect(() => {
    if (quoteId) {
      dispatch(getGeneralPartyInfoByIdAction(quoteId));
    }
    else if(id)
    {
       dispatch(getGeneralPartyInfoByIdAction(id));
    }
  }, []);

  useEffect(() => {
    const uniqueCities = cityData.reduce((acc, city) => {
      const key = `${city.cityName}-${city.stateCode}`;
      if (!acc.find((c) => `${c.cityName}-${c.stateCode}` === key)) {
        acc.push({
          ...city,
          displayName: `${city.cityName}, ${city.stateCode}`,
          searchKey: city.cityName.toLowerCase(),
        });
      }
      return acc;
    }, []);
    setCityOptions(
      uniqueCities.sort((a, b) => a.cityName.localeCompare(b.cityName))
    );
  }, [cityData]);

  const generalParty = useSelector(
    (state) => state.generalPartyInfo.allGeneralPartyInfo
  );
  const generalPartyInfo =
  generalParty && Object.keys(generalParty).length > 0
    ? generalParty
    : generalData;
  const { formData, touchedFields, fieldErrors } = formState;
  const location = useLocation();

  useEffect(() => {
    const checkExistingUser = async () => {
      const { firstName, lastName, dob, cellPhone } = formData;
      const allFieldsManuallyEdited = Object.values(manuallyEdited).every(
        (value) => value
      );

      if (
        firstName &&
        lastName &&
        dob &&
        cellPhone &&
        !fieldErrors.firstName &&
        !fieldErrors.lastName &&
        !fieldErrors.dob &&
        !fieldErrors.cellPhone &&
        !hasCheckedExisting &&
        allFieldsManuallyEdited
      ) {
        try {
          const updatedPhone = convertToE164(cellPhone);
          const response = await dispatch(
            getQuoteInfoByFields(firstName, lastName, dob, updatedPhone)
          );

          if (response && Array.isArray(response) && response.length > 0) {
            setHasCheckedExisting(true);
            setExistingUsers(response);
            setSelectedUser(response[0]);
            setDialogOpen(true);
          }
        } catch (error) {
          setHasCheckedExisting(false);
          console.error("Error checking existing user:", error);
          handleSnackbarOpen(
            "Error checking for existing user information",
            "error"
          );
        }
      }
    };

    checkExistingUser();
  }, [formData.firstName, formData.lastName, formData.dob, formData.cellPhone]);

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";

    // Remove +1 if present, then remove all non-digits
    const cleaned = phoneNumber.startsWith("+1")
      ? phoneNumber.slice(2).replace(/\D/g, "")
      : phoneNumber.replace(/\D/g, "");

    // Limit to exactly 10 digits
    const digitsOnly = cleaned.slice(0, 10);

    // Format as XXX-XXX-XXXX only if we have digits
    if (digitsOnly.length === 0) return "";

    const match = digitsOnly.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      let formatted = match[1];
      if (match[2]) formatted += `-${match[2]}`;
      if (match[3]) formatted += `-${match[3]}`;
      return formatted;
    }

    return digitsOnly;
  };

  const debouncedCitySearch = useCallback(
    debounce((searchTerm, stateCode = "") => {
      if (searchTerm.length >= 2) {
        dispatch(searchCitiesAction(searchTerm, stateCode, 20));
      }
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (location?.state && location?.state?.customerData) {
      const cust = location?.state?.customerData;
       setQuoteId(cust.gpId);
      const mappedData = {
        firstName: cust.firstName || "",
        lastName: cust.lastName || "",
        email: cust.email || "",
        cellPhone: formatPhoneNumber(cust.cellPhone) || "",
        address: cust.address ||cust.addressLine1|| "",
        gender: cust.gender || "",
        state: cust.state || "",
        zip: (cust.zip || cust.zipCode)?.toString() || "",
        city: cust.city || "",
        apartmentNumber: cust.apartmentNumber || "",
        ownedRented: cust.ownedRented || "",
        dob: (cust.dob ?? cust.dateOfBirth)
  ? dayjs(cust.dob ?? cust.dateOfBirth).format("MM-DD-YYYY")
  : "",
        residenceYear: cust.residenceYear || "",
        residenceMonth: cust.residenceMonth || "",
        clientCustomerId: cust.clientCustomerId,
      };
      setFormState((prevState) => ({
        ...prevState,
        formData: {
          ...prevState.formData,
          ...mappedData,
        },
        touchedFields: {
          ...prevState.touchedFields,
          ...Object.keys(mappedData).reduce(
            (acc, key) => ({
              ...acc,
              [key]: true,
            }),
            {}
          ),
        },
        fieldErrors: {
          ...prevState.fieldErrors,
          ...Object.keys(mappedData).reduce(
            (acc, key) => ({
              ...acc,
              [key]: "",
            }),
            {}
          ),
        },
      }));
      const checkExistingUserFromNavigation = async () => {
        const { firstName, lastName, dob, cellPhone } = mappedData;

        if (firstName && lastName && dob && cellPhone) {
          try {
            const updatedPhone = convertToE164(cellPhone);
            const response = await dispatch(
              getQuoteInfoByFields(firstName, lastName, dob, updatedPhone)
            );

            if (response && Array.isArray(response) && response.length > 0) {
              setHasCheckedExisting(true);
              setExistingUsers(response);
              setSelectedUser(response[0]);
              setDialogOpen(true);
            }
          } catch (error) {
            setHasCheckedExisting(false);
            console.error("Error checking existing user:", error);
            handleSnackbarOpen(
              "Error checking for existing user information",
              "error"
            );
          }
        }
      };

      checkExistingUserFromNavigation();
    }
  }, [location.state]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (["firstName", "lastName", "dob", "cellPhone"].includes(name)) {
      setManuallyEdited((prev) => ({
        ...prev,
        [name]: true,
      }));
      setHasCheckedExisting(false);
    }
    setFormState((prevState) => {
      let formattedValue = value;
      let error = "";

      if (name === "cellPhone") {
        formattedValue = formatPhoneNumber(value);
        error = validationFunctions[name]
          ? validationFunctions[name](formattedValue)
          : "";
      } else if (name === "zip") {
        formattedValue = value.replace(/\D/g, "").slice(0, 5);
        error = validationFunctions[name]
          ? validationFunctions[name](formattedValue)
          : "";
      } else if (name === "firstName" || name === "lastName") {
        formattedValue = value.replace(/[^a-zA-Z0-9 ]/g, "");
      } else if (name === "city") {
        formattedValue = value.replace(/[^a-zA-Z ]/g, "");
      } else if (name === "apartmentNumber") {
        formattedValue = value.replace(/[^a-zA-Z0-9\s\-\.#]/g, "");
        error = validationFunctions[name]
          ? validationFunctions[name](formattedValue)
          : "";
      } else {
        error = validationFunctions[name]
          ? validationFunctions[name](value)
          : "";
      }

      return {
        ...prevState,
        touchedFields: {
          ...prevState.touchedFields,
          [name]: true,
        },
        formData: {
          ...prevState.formData,
          [name]: formattedValue,
        },
        fieldErrors: {
          ...prevState.fieldErrors,
          [name]: error,
        },
      };
    });
  };

  const handleDateChange = (date, fieldName) => {
    if (fieldName === "dob") {
      setManuallyEdited((prev) => ({
        ...prev,
        dob: true,
      }));
      setHasCheckedExisting(false);
    }
    if (!date || !dayjs(date).isValid()) {
      setFormState((prevState) => ({
        ...prevState,
        formData: {
          ...prevState.formData,
          [fieldName]: "",
        },
        touchedFields: {
          ...prevState.touchedFields,
          [fieldName]: true,
        },
        fieldErrors: {
          ...prevState.fieldErrors,
          [fieldName]: "Please select a valid date",
        },
      }));
      return;
    }

    const formattedDate = dayjs(date).format("MM-DD-YYYY");

    const validationError = validationFunctions.dob(formattedDate);

    setFormState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [fieldName]: formattedDate,
      },
      touchedFields: {
        ...prevState.touchedFields,
        [fieldName]: true,
      },
      fieldErrors: {
        ...prevState.fieldErrors,
        [fieldName]: validationError,
      },
    }));
  };

  const handleBlur = (field) => {
    setFormState((prevFormState) => {
      const value = prevFormState.formData[field];
      let error = "";
    let trimmedValue = value;
    if (field === 'firstName' || field === 'lastName') {
      trimmedValue = typeof value === 'string' ? value.trim() : value;
    }
      if (field === "state") {
        error = validateStateField(value);
      } else {
        if (requiredFields.includes(field)) {
          error = validateField(
            value,
            newFieldArg.find((rule) => rule.fieldName === field).label
          );

          const additionalError = validationFunctions[field]
            ? validationFunctions[field](value)
            : "";

          error = error || additionalError;
        }
      }

      return {
        ...prevFormState,
        formData: {
        ...prevFormState.formData,
        [field]: trimmedValue, // Update with trimmed value
      },
        touchedFields: {
          ...prevFormState.touchedFields,
          [field]: true,
        },
        fieldErrors: {
          ...prevFormState.fieldErrors,
          [field]: error,
        },
      };
    });
  };

  const handleSnackbarClose = () => {
    setSnackbar((prevSnackbar) => ({
      ...prevSnackbar,
      open: false,
    }));
  };

  const handleSnackbarOpen = (message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const dobValue = dayjs(
      formData.dob,
      ["YYYY-MM-DD", "MM-DD-YYYY", "MM/DD/YYYY"],
      true
    );

    const formattedFormData = {
      ...formData,
      dob: dobValue.isValid() ? dobValue.format("MM-DD-YYYY") : "",
    };
    handleSubmitGeneralTab(formattedFormData);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationErrors = newFieldArg.reduce(
      (errors, { fieldName, label }) => {
        if (requiredFields.includes(fieldName)) {
          const value = formData[fieldName];
          const error = validateField(value, label);
          const additionalError = validationFunctions[fieldName]
            ? validationFunctions[fieldName](value)
            : "";

          setFormState((prevFormState) => ({
            ...prevFormState,
            fieldErrors: {
              ...prevFormState.fieldErrors,
              [fieldName]: error || additionalError,
            },
          }));

          return {
            ...errors,
            [fieldName]: error || additionalError,
          };
        }

        return errors;
      },
      {}
    );

    const hasErrors = Object.values(validationErrors).some((error) => !!error);

    if (!hasErrors) {
      try {
        const payloadFormData = {
          ...formData,
          cellPhone: convertToE164(formData.cellPhone),
          dob: dayjs(formData.dob, ["MM-DD-YYYY"], true).isValid()
            ? dayjs(formData.dob, ["MM-DD-YYYY"], true).format("MM-DD-YYYY")
            : "",
        };
        if (quoteId || id) {
          const newFormData = {
            ...formData,
              cellPhone: convertToE164(formData.cellPhone),
            id: parseInt(quoteId),
          };
          await dispatch(
            updateGeneralPartyInfo(newFormData, getCreateUserSuccess)
          );
        } else {
          const newFormData = {
            ...payloadFormData,
             ...(customerId ? { clientCustomerId: customerId } : {})
          };
          await dispatch(
            createGeneralPartyInfoAction(newFormData, getCreateUserSuccess)
          );
          const dobValue = dayjs(
            formData.dob,
            ["YYYY-MM-DD", "MM-DD-YYYY", "MM/DD/YYYY"],
            true
          );

          const formattedFormData = {
            ...formData,
            dob: dobValue.isValid() ? dobValue.format("MM-DD-YYYY") : "",
          };
          handleSubmitGeneralTab(formattedFormData);
        }
      } catch (error) {
        handleSnackbarOpen(
          error.message || "User service failed. Please try again.",
          "error"
        );
      }
    } else {
      handleSnackbarOpen(
        "Validation errors detected. Please correct them.",
        "error"
      );
    }
    handleNext();
  };

  const handleMainSubmit = (event) => {
    if (generalPartyInfo && Object.keys(generalPartyInfo).length > 0) {
      handleFormSubmit(event);
    } else {
      handleSubmit(event);
    }
  };

  const getCreateUserSuccess = async (uid) => {
    await dispatch(setGpId(uid))
    handleSnackbarOpen("Created successfully.", "success");
    await dispatch(tabActions(1));
  };

  useEffect(() => {
    if (generalPartyInfo) {
      setManuallyEdited({
        firstName: false,
        lastName: false,
        dob: false,
        cellPhone: false,
      });
    }
  }, [generalPartyInfo]);

  useEffect(() => {
    if (location.state?.customerData) return;

    if (generalPartyInfo) {
      const mappedData = newFieldArg.reduce((fields, { fieldName }) => {
        return {
          ...fields,
          [fieldName]:
            populateValue(
              generalPartyInfo[fieldName],
              fieldName,
              newFieldArg
            ) || "",
        };
      }, {});

      setFormState((prevFormState) => ({
        ...prevFormState,
        formData: {
          ...prevFormState.formData,
          ...mappedData,
        },
        touchedFields: {
          ...prevFormState.touchedFields,
          ...Object.keys(mappedData).reduce(
            (acc, key) => ({
              ...acc,
              [key]: true,
            }),
            {}
          ),
        },
        fieldErrors: {
          ...prevFormState.fieldErrors,
          ...Object.keys(mappedData).reduce(
            (acc, key) => ({
              ...acc,
              [key]: "",
            }),
            {}
          ),
        },
      }));
    }
  }, [generalPartyInfo, location.state]);
  const isDirty = () => {
  // If any field has been touched, consider the form dirty
  const anyTouched = Object.values(formState.touchedFields || {}).some(Boolean);
  return anyTouched;
};


  const isFormValid = () => {
  const allRequiredFieldsFilled = requiredFields.every((fieldName) => {
    const value = formData[fieldName];
    return value && value.toString().trim() !== "";
  });
  const noValidationErrors = requiredFields.every((fieldName) => !fieldErrors[fieldName]);
  return allRequiredFieldsFilled && noValidationErrors;
};


const doResetForm = () => {
  const emptyFormData = validationRules.reduce(
    (fields, { fieldName }) => ({ ...fields, [fieldName]: "" }),
    {}
  );
  setFormState({
    formData: emptyFormData,
    touchedFields: validationRules.reduce((f, { fieldName }) => ({ ...f, [fieldName]: false }), {}),
    fieldErrors: validationRules.reduce((e, { fieldName }) => ({ ...e, [fieldName]: "" }), {}),
  });
  setManuallyEdited({ firstName: false, lastName: false, dob: false, cellPhone: false });
  setHasCheckedExisting(false);
  setExistingUsers([]);
  setSelectedUser(null);
  setUseGpId(false);
  setSelectedCity(null);
  setCitySearchTerm("");
};

// Save same as your “Submit” branch, but without calling handleNext / handleSubmitGeneralTab
const saveWithoutNav = async () => {
  // Validate first
  const validationErrors = validationRules.reduce((errors, { fieldName, label }) => {
    if (requiredFields.includes(fieldName)) {
      const value = formData[fieldName];
      const baseErr = validateField(value, label);
      const extraErr = validationFunctions[fieldName] ? validationFunctions[fieldName](value) : "";
      return { ...errors, [fieldName]: baseErr || extraErr };
    }
    return errors;
  }, {});

  const hasErrors = Object.values(validationErrors).some(Boolean);
  if (hasErrors) {
    setFormState((prev) => ({ ...prev, fieldErrors: { ...prev.fieldErrors, ...validationErrors } }));
    handleSnackbarOpen("Validation errors detected. Please correct them.", "error");
    return { ok: false };
  }

  try {
    const newPayload = {
      ...formData,
      cellPhone: convertToE164(formData.cellPhone),
      dob: dayjs(formData.dob, ["MM-DD-YYYY"], true).isValid()
        ? dayjs(formData.dob, ["MM-DD-YYYY"], true).format("MM-DD-YYYY")
        : "",
      ...(customerId ? { clientCustomerId: customerId } : {}),
    };

    if (quoteId || id) {
      const updatePayload = {...generalPartyInfo, ...newPayload, gpId: parseInt(quoteId || id) };
      await dispatch(updateGeneralPartyInfo(updatePayload, getCreateUserSuccess));
    } else {
      await dispatch(createGeneralPartyInfoAction(newPayload, getCreateUserSuccess));
    }
    handleSnackbarOpen("Saved successfully.", "success");
    return { ok: true };
  } catch (error) {
    handleSnackbarOpen(error?.message || "User service failed. Please try again.", "error");
    return { ok: false };
  }
};

useImperativeHandle(ref, () => ({
  shouldConfirm: () => isDirty() && isFormValid(),
  saveWithoutNav,
  resetForm: doResetForm,
}));
console.log(theme, 'theme in general tab');
  return (
    <>
      <Box
        sx={{
          padding: isMobile ? "8px" : "24px",
          backgroundColor: "#ffffff",
          overflowX: "auto",
          minHeight: "40vh",
          "@media (min-width: 768px) and (max-width: 1024px)": {
            minHeight: "100vh",
            height: "auto",
            overflowY: "auto",
          },
          "@media (min-width: 1024px) and (min-height: 1366px)": {
            height: "auto",
            minHeight: "110vh",
          },
        }}
      >
        <Box
          id="form"
          component="form"
          onSubmit={handleMainSubmit}
          noValidate
          sx={{
            width: "100%",
            maxWidth: "853px",
            margin: "0 auto",
            borderRadius: "4px",
            backgroundColor: "#fff",
            border: "1px solid #e3e3e3",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "flex-start",
            padding: isMobile ? "20px 10px" : "30px 0px 24px",
          }}
        >
          <Typography
            id="clientinformation"
            variant="h1"
            component="div"
            sx={{
              border: "none",
              backgroundColor: "transparent",
              alignSelf: "stretch",
              height: "51px",
              fontFamily: '"Poppins", sans-serif',
              fontWeight: "600",
              fontSize: isMobile ? "20px" : "25px",
              color: dynamicTheme?.secondaryColor,
              paddingLeft: isMobile ? "20px" : "50px",
              display: "flex",
              marginBottom: "1.5rem",
              alignItems: "center",
            }}
          >
            Client Information
          </Typography>
          <hr style={{ borderTop: "1px solid #ccc", width: "100%" }} />
          <Box
            sx={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "flex-end",
              padding: isMobile ? "0px 10px" : "0px 44px 0px 52px",
              boxSizing: "border-box",
              maxWidth: "100%",
              marginTop: "1rem",
            }}
          >
            <Box
              sx={{
                flex: "1",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: "16px",
                maxWidth: "100%",
              }}
            >
              <Box
                sx={{
                  flex: "1",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  minWidth: isMobile ? "100%" : "240px",
                  maxWidth: "100%",
                }}
              >
                <Box
                  sx={{
                    alignSelf: "stretch",
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                    gap: "5px 20px",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    padding: "0px 0px 8px",
                  }}
                >
                  {validationRules.map(
                    (
                      { fieldName, label, type, option, groupLabel = "" },
                      index
                    ) => (
                      <Box
                        sx={{
                          display: "flex",
                          flexFlow: "column",
                          margin: "0 0 15px 0",
                          width: "100%",
                        }}
                        key={index}
                      >
                        {groupLabel && (
                          <Grid item xs={12} style={{ marginBottom: 0 }}>
                            <Typography
                              variant="subtitle1"
                              style={{
                                position: "relative",
                                fontWeight: "500",
                                display: "inline-block",
                                minWidth: "83px",
                                zIndex: "1",
                                fontFamily: '"Poppins", sans-serif',
                                color: dynamicTheme?.secondaryColor,
                              }}
                            >
                              {groupLabel}
                            </Typography>
                          </Grid>
                        )}
                        <Typography
                          key={fieldName}
                          variant="body1"
                          sx={{
                            position: "relative",
                            lineHeight: "18px",
                            fontWeight: "500",
                            display: "inline-block",
                            zIndex: "1",
                            margin: "0 0 10px 0",
                            fontFamily: '"Poppins", sans-serif',
                            color: dynamicTheme?.secondaryColor,
                          }}
                        >
                          {label}
                          {requiredFields.includes(fieldName) && fieldName !== "cellPhone" && (
                            <span style={{ color: "red", marginLeft: "2px" }}>
                              *
                            </span>
                          )}
                        </Typography>

                        {fieldName === "dob" ? (
                          <Box sx={{ marginTop: "-3px" }}>
                          <DatePickerField
                            fieldName="dob"
                            formData={formData}
                            handleDateChange={handleDateChange}
                            handleBlur={handleBlur}
                            touchedFields={touchedFields}
                            fieldErrors={fieldErrors}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "75px",
                              },
                              "& .MuiInputBase-input": {
                                padding: "14px",
                              },
                            }}
                          />
                          </Box>
                        ) : type === "select" ? (
                          <FormControl fullWidth variant="outlined">
                            <Select
                              native
                              name={fieldName}
                              value={formData[fieldName] || ""}
                              onChange={handleInputChange}
                              onBlur={() => handleBlur(fieldName)}
                              error={
                                touchedFields[fieldName] &&
                                !!fieldErrors[fieldName]
                              }
                              displayEmpty
                              inputProps={{ "aria-label": label }}
                              sx={{
                                height: "52px",
                                "& .MuiInputBase-root": {
                                  height: "52px",
                                  backgroundColor: "#fff",
                                  fontSize: "14px",
                                  fontFamily: '"Poppins", sans-serif',
                                },
                                "& .MuiInputBase-input": {
                                  color: dynamicTheme?.secondaryColor,
                                },
                                "& fieldset": {
                                  borderColor:
                                    touchedFields[fieldName] &&
                                    !!fieldErrors[fieldName]
                                      ? "#d32f2f"
                                      : "#C1C1C1",
                                },
                              }}
                            >
                              <option value="" disabled>
                                Select {label}
                              </option>
                              {option?.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </Select>
                            {touchedFields[fieldName] &&
                              fieldErrors[fieldName] && (
                                <FormHelperText error>
                                  {fieldErrors[fieldName]}
                                </FormHelperText>
                              )}
                          </FormControl>
                        ) : fieldName === "cellPhone" ? (
                          <PhoneNumberField
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                              alignSelf: "stretch",
                              fontFamily: '"Poppins", sans-serif',
                              fontWeight: "500",
                              fontSize: "16px",
                              zIndex: "1",
                            }}
                            type="text"
                            variant="outlined"
                            label="Cell Phone"
                            labelStyle={{ marginBottom: "8px",mt:-2 }}
                            required={requiredFields.includes(fieldName)}
                            InputProps={{
                              style: { height: "45px", fontSize: 16 },
                              inputProps: {
                                maxLength: 12, // XXX-XXX-XXXX format (10 digits + 2 dashes)
                                inputMode: "numeric", // Show numeric keypad on mobile
                              },
                            }}
                            id={fieldName}
                            placeholder="123-456-7890"
                            name={fieldName}
                            autoComplete={fieldName}
                            value={formData[fieldName] || ""}
                            onChange={handleInputChange}
                            onBlur={() => handleBlur(fieldName)}
                            error={
                              touchedFields[fieldName] &&
                              !!fieldErrors[fieldName]
                            }
                            helperText={
                              touchedFields[fieldName]
                                ? fieldErrors[fieldName]
                                : ""
                            }
                            sx={{
                              "& fieldset": {
                                borderColor: "#C1C1C1",
                              },
                              "& .MuiInputBase-root": {
                                height: "45px",
                                backgroundColor: "#fff",
                                fontSize: "14px",
                                fontFamily: '"Poppins", sans-serif',
                              },
                              "& .MuiInputBase-input": {
                                color: dynamicTheme?.secondaryColor,
                              },
                            }}
                          />
                        ) : fieldName === "city" ? (
                          <Autocomplete
                            id="city"
                            options={cityOptions}
                            getOptionLabel={(option) =>
                              option.displayName || option.cityName || ""
                            }
                            inputValue={formData.city}
                            value={selectedCity}
                            onInputChange={(event, newValue, reason) => {
                              if (reason === "input") {
                                setCitySearchTerm(newValue);
                                setSelectedCity(null);
                                debouncedCitySearch(newValue, formData.state);
                                setFormState((prev) => ({
                                  ...prev,
                                  formData: {
                                    ...prev.formData,
                                    city: newValue,
                                  },
                                  touchedFields: {
                                    ...prev.touchedFields,
                                    city: true,
                                  },
                                  fieldErrors: {
                                    ...prev.fieldErrors,
                                    city: validateCity(newValue),
                                  },
                                }));
                              } else if (reason === "clear") {
                                // Handle clear button click
                                setCitySearchTerm("");
                                setSelectedCity(null);
                                setFormState((prev) => ({
                                  ...prev,
                                  formData: {
                                    ...prev.formData,
                                    city: "",
                                    state: "",
                                  }, // Reset city and optionally state
                                  touchedFields: {
                                    ...prev.touchedFields,
                                    city: true,
                                  },
                                  fieldErrors: {
                                    ...prev.fieldErrors,
                                    city: validateCity(""), // Validate empty city
                                  },
                                }));
                              }
                            }}
                            onChange={(event, selectedOption) => {
                              if (selectedOption) {
                                setSelectedCity(selectedOption);
                                setCitySearchTerm(selectedOption.displayName);
                                setFormState((prev) => ({
                                  ...prev,
                                  formData: {
                                    ...prev.formData,
                                    city: selectedOption.cityName,
                                    state: selectedOption.stateCode,
                                  },
                                  touchedFields: {
                                    ...prev.touchedFields,
                                    city: true,
                                    state: true,
                                  },
                                  fieldErrors: {
                                    ...prev.fieldErrors,
                                    city: "",
                                    state: "",
                                  },
                                }));
                              }
                            }}
                            filterOptions={(x) => x}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Start typing city name..."
                                error={touchedFields.city && !!fieldErrors.city}
                                helperText={
                                  touchedFields.city && fieldErrors.city
                                }
                                fullWidth
                                onBlur={() => handleBlur("city")}
                                sx={{
                                  "& fieldset": {
                                    borderColor: "#C1C1C1",
                                  },
                                  "& .MuiInputBase-root": {
                                    height: "52px",
                                    backgroundColor: "#fff",
                                    fontSize: "16px",
                                    fontFamily: '"Poppins", sans-serif',
                                  },
                                  "& .MuiInputBase-input": {
                                    color: dynamicTheme?.secondaryColor,
                                  },
                                }}
                              />
                            )}
                          />
                        ) : (
                          <TextField
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                              alignSelf: "stretch",
                              fontFamily: '"Poppins", sans-serif',
                              fontWeight: "500",
                              fontSize: "16px",
                              zIndex: "1",
                            }}
                            type="text"
                            variant="outlined"
                            required={requiredFields.includes(fieldName)}
                            InputProps={{
                              style: { height: 52, fontSize: 16 },
                              inputProps: {
                                min: type === "number" ? "0" : "",
                                max: type === "date" ? "2008-04-04" : "",
                                maxLength: type === "email" ? 50 : 50,
                              },
                            }}
                            id={fieldName}
                            placeholder={label}
                            name={fieldName}
                            autoComplete={fieldName}
                            value={formData[fieldName] || ""}
                            maxLength={15}
                            onChange={(e) => {
                              if (fieldName === "phoneNumber") {
                                const formattedPhone = formatPhoneNumber(
                                  e.target.value
                                );
                                handleInputChange({
                                  target: {
                                    name: fieldName,
                                    value: formattedPhone,
                                  },
                                });
                              } else {
                                handleInputChange(e);
                              }
                            }}
                            onBlur={() => handleBlur(fieldName)}
                            error={
                              touchedFields[fieldName] &&
                              !!fieldErrors[fieldName]
                            }
                            helperText={
                              touchedFields[fieldName]
                                ? fieldErrors[fieldName]
                                : ""
                            }
                            sx={{
                              "& fieldset": {
                                borderColor: "#C1C1C1",
                              },
                              "& .MuiInputBase-root": {
                                height: "52px",
                                backgroundColor: "#fff",
                                fontSize: "14px",
                                fontFamily: '"Poppins", sans-serif',
                              },
                              "& .MuiInputBase-input": {
                                color: dynamicTheme?.secondaryColor,
                              },
                            }}
                          />
                        )}
                      </Box>
                    )
                  )}
                </Box>
              </Box>
            </Box>
          </Box>

          <div
            style={{
              alignSelf: "stretch",
              height: "42px",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "flex-end",
              marginRight: isMobile ? "20px" : "45px",
              position: "relative",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <Button
              id="submitbutton"
              type="submit"
              disabled={!isFormValid()}
              style={{
                alignSelf: "stretch",
                width: "104px",
                // cursor: "pointer",
                cursor: !isFormValid() ? "not-allowed" : "pointer",
                zIndex: "1",
                fontFamily: '"Poppins", sans-serif',
              }}
              endIcon={<ArrowForwardIosIcon />}
              variant="contained"
              sx={{
                background: !isFormValid()
                  ? theme.palette.secondary.light
                  : theme.palette.primary.light,
                }}
            >
              Next
            </Button>
          </div>
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
});

export default GeneralTab;
